import clsx from 'clsx';
import React from 'react';

interface TestimonialStatsProps {
  stat: string;
  description: string;
  variant: 'light' | 'dark';
}

export const TestimonialStats = ({ stat, description, variant }: TestimonialStatsProps) => {
  const statClasses = clsx(
    'text-h5 relative pl-4 before:absolute before:left-0 before:top-1 before:h-7 before:border-l-2 before:border-l-gradle-blue before:pl-4',
    {
      'text-light-blue': variant === 'dark',
      'text-gray-1': variant === 'light',
    },
  );

  const descriptionClasses = clsx('text-body h-[2.7em] pl-4 md:min-h-12 md:pl-0 lg:pl-0 xl:pl-0', {
    'text-gray-4': variant === 'dark',
    'text-gray-2': variant === 'light',
  });

  return (
    <div className="flex w-56 flex-1 basis-full flex-col gap-2 md:w-auto">
      <p className={statClasses}>{stat}</p>
      <p className={descriptionClasses}>{description}</p>
    </div>
  );
};
